<div *ngIf="title; else standard" class="d-flex justify-content-between align-items-center mb-1">
  <h4>{{title}}</h4>
  <div class="close-btn" (click)="close()"><i class="lni-close"></i></div>
</div>

<ng-template #standard>
  <div class="close-container">
    <div class="close-btn" (click)="close()"><i class="lni-close"></i></div>
  </div>
</ng-template>

<div [innerHtml]="message | safeHtml"> </div>
